module.exports = __webpack_public_path__ + "static/media/app-process-2-vertical.4b9b0ad1.png";